














import {Component, Vue} from 'vue-property-decorator';
import Table from '@c/tables/Table.vue';
import EditDialog from './UserEditDialog.vue';
import {UserTableHeader} from './interfaces';
import userStoreModule from '@/store/modules/entities/userModule';
import {Can} from '@casl/vue';

@Component({
  components: {
    Table,
    EditDialog,
    Can,
  },
})
export default class AdministrationUsers extends Vue {
  get apiStore() {
    return userStoreModule;
  }

  private editDialog = EditDialog;

  headers: UserTableHeader[] = [
    {
      text: 'Имя пользователя',
      value: 'login',
      sortable: false,
    },
    {
      text: 'ФИО',
      value: 'name',
      sortable: false,
    },
    {
      text: 'Email',
      value: 'email',
      sortable: false,
    },
  ];
}
